import { render, staticRenderFns } from "./help_video.vue?vue&type=template&id=6dd7bcff&scoped=true&"
import script from "./help_video.vue?vue&type=script&lang=js&"
export * from "./help_video.vue?vue&type=script&lang=js&"
import style0 from "./help_video.vue?vue&type=style&index=0&id=6dd7bcff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd7bcff",
  null
  
)

export default component.exports